//* Hooks imports
import { useEffect, useMemo, useState, useCallback } from "react";

//* Components Import
import { Form, Row, Col } from "react-bootstrap";

//* Libraries imports
import { motion } from "framer-motion";

// * Animations imports
import { formItemVariants } from "../animations";

type DeadlineInfoProps = {
  date: string;
  time: string;
  register: any;
  errors: any;
  setValue: any;
  disabled?: boolean;
};

export const DeadlineInfo = ({
  date,
  time,
  register,
  errors,
  setValue,
  disabled = false,
}: DeadlineInfoProps) => {
  const today = useMemo(() => new Date().toISOString().split("T")[0], []);

  const [timeValue, setTimeValue] = useState(() => {
    return time ? time.substring(0, 5) : "23:59";
  });
  const updateCombinedDateTime = useCallback(
    (newDate: string, newTime: string) => {
      setValue("hora_limite", newTime);
      setValue("data_limite", newDate);
    },
    [setValue]
  );
  useEffect(() => {
    if (date && date < today) {
      setValue("data_limite", today);
      updateCombinedDateTime(today, timeValue);
    }
  }, [date, today, setValue, timeValue, updateCombinedDateTime]);

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTime = e.target.value;
    setTimeValue(newTime);
    updateCombinedDateTime(date, newTime);
  };
  return (
    <motion.div
      className="deadline-info mb-4"
      variants={formItemVariants}
      custom={3}
    >
      <Row>
        <Col md={6}>
          <Form.Group className="mb-2">
            <Form.Label htmlFor="dataLimiteField" className="mb-0 fw-bold">
              Data-limite
            </Form.Label>{" "}
            <Form.Control
              id="dataLimiteField"
              type="date"
              title="Data-limite para envio do recurso"
              aria-label="Data-limite para envio do recurso"
              disabled={disabled}
              isInvalid={!!errors?.data_limite}
              defaultValue={date}
              onChange={(e) =>
                updateCombinedDateTime(e.target.value, timeValue)
              }
              {...register("data_limite")}
            />
            {errors?.data_limite && (
              <motion.div
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <Form.Text className="text-danger">
                  {errors.data_limite.message}
                </Form.Text>
              </motion.div>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-2">
            <Form.Label htmlFor="horaLimiteField" className="mb-0 fw-bold">
              Horário-limite
            </Form.Label>{" "}
            <Form.Control
              id="horaLimiteField"
              type="time"
              title="Horário-limite para envio do recurso"
              aria-label="Horário-limite para envio do recurso"
              disabled={disabled}
              value={timeValue}
              onChange={handleTimeChange}
            />
          </Form.Group>
        </Col>
      </Row>
    </motion.div>
  );
};
